<script setup lang="ts">
import type { IProps } from './UiExpander.types'

defineProps<IProps>()
const expand = ref(false)
</script>

<template>
  <div class="uiExpander">
    <transition
      name="expand"
    >
      <div
        v-show="expand"
        class="uiExpander__content"
      >
        <slot />
      </div>
    </transition>

    <span
      :class="['uiExpander__button', expand && 'uiExpander__button--expand']"
      @click="expand = !expand"
    >
      {{ !expand ? textToShow : textToHide }}
    </span>
  </div>
</template>

<style>
.expand-enter-active, .expand-leave-active {
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

.expand-enter-from, .expand-leave-to {
  max-height: 0;
  opacity: 0;
}

.expand-enter-to, .expand-leave-from {
  max-height: 600px; /* Dopasuj do rzeczywistego rozmiaru */
  opacity: 1;
}

</style>

<style lang="scss" scoped>
.uiExpander {
  &__content {
    margin-top: 1.6rem;
  }

  &__button {
    @include body-2-medium;
    display: flex;
    margin: 1.6rem 0;
    color: $text-400;
    cursor: pointer;
    transition: transform 0.3s ease-in-out;

    &:after {
      display: inline-block;
      width: 2.4rem;
      height: 2.4rem;
      margin-left: 0.8rem;
      background-image: url('/icons/icon_arrow_down.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      content: '';
    }

    &--expand {
      &:after {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
